// 判斷是否為開發環境
const isDev = import.meta.env.DEV

// 主系統 URL
// 開發環境：使用 localhost:3000
// 生產環境：使用環境變數或預設值
export const MAIN_SYSTEM_URL = isDev
  ? 'http://localhost:3000'
  : (import.meta.env.VITE_MAIN_SYSTEM_URL || 'https://sonice-aioe-portal.sonice-aioe.com')

// Supabase 配置
export const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL
export const SUPABASE_ANON_KEY = import.meta.env.VITE_SUPABASE_ANON_KEY
